import React, {useEffect} from "react";
import {useFunnel} from "../../../context/FunnelContext";
import confetti from "canvas-confetti";

export function SuccessPayment() {
    const {state} = useFunnel();

    useEffect(() => {
        // Enhanced confetti animation
        const duration = 3000;
        const animationEnd = Date.now() + duration;

        const confettiColors = ["#22c55e", "#3b82f6", "#f59e0b"];

        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            confetti({
                particleCount: 3,
                angle: 60,
                spread: 55,
                origin: {x: 0},
                colors: confettiColors,
            });
            confetti({
                particleCount: 3,
                angle: 120,
                spread: 55,
                origin: {x: 1},
                colors: confettiColors,
            });
        }, 150);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-green-50 to-white py-12 px-4">
            <div className="max-w-md mx-auto space-y-8">
                {/* Success Icon with Animation */}
                <div className="text-center">
                    <div
                        className="mx-auto w-24 h-24 bg-green-100 rounded-full flex items-center justify-center animate-bounce">
                        <svg
                            className="w-12 h-12 text-green-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                    </div>
                </div>

                {/* Success Message */}
                <div className="text-center animate-fadeIn">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        Welcome to Caloria! 🎉
                    </h1>
                    <p className="text-lg text-gray-600 mb-8">
                        Your journey to a healthier lifestyle begins now.
                    </p>
                </div>

                {/* Plan Details Card */}
                <div
                    className="bg-white rounded-2xl p-6 shadow-xl border border-green-100 transform hover:scale-105 transition-transform duration-300">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
            <span className="bg-green-100 p-2 rounded-full mr-3">
              <svg
                  className="w-5 h-5 text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
              >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
                        Your Plan Details
                    </h2>
                    <div className="space-y-3">
                        <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                            <span className="text-gray-600">Plan</span>
                            <span className="font-medium text-gray-900">
                {state.userData.selectedPlan.duration}
              </span>
                        </div>
                        <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                            <span className="text-gray-600">Amount</span>
                            <span className="font-medium text-green-500">
                ${state.userData.selectedPlan.discountedPrice}
              </span>
                        </div>
                    </div>
                </div>

                {/* Next Steps Card */}
                <div className="bg-white rounded-2xl p-6 shadow-xl border border-green-100">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
            <span className="bg-blue-100 p-2 rounded-full mr-3">
              <svg
                  className="w-5 h-5 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
              >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </span>
                        Next Steps
                    </h2>
                    <div className="space-y-4">
                        {[
                            {
                                step: 1,
                                title: "Download the App",
                                description: "Get Caloria from the App Store or Google Play",
                            },
                            {
                                step: 2,
                                title: "Sign In",
                                description: `Use your email: ${state.userData.email}`,
                            },
                            {
                                step: 3,
                                title: "Start Your Journey",
                                description: "Begin your path to a healthier lifestyle!",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                            >
                                <div
                                    className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                    <span className="text-blue-500 font-medium">{item.step}</span>
                                </div>
                                <div>
                                    <h3 className="font-medium text-gray-900">{item.title}</h3>
                                    <p className="text-sm text-gray-600">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Download Buttons */}
                <div className="flex gap-4 animate-fadeIn">
                    <a
                        href="https://apps.apple.com/app/id6738032172"
                        className="flex-1 bg-black text-white rounded-xl py-4 px-6 flex items-center justify-center gap-2 hover:bg-gray-800 transition-colors duration-200 shadow-lg transform hover:-translate-y-1"
                    >
                        <img src="/apple_logo.svg" alt="Apple" className="h-6"/>
                        <span className="font-medium">Download on App Store</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
